"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _Menu = _interopRequireDefault(require("../Menu"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _TypographyList = require("./TypographyList");
var _styles = require("@gogame/ui/styles");
var _clsx2 = _interopRequireDefault(require("clsx"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "PaperProps", "menuVariant", "anchorProps", "count", "unitsLabel", "disableMenu"],
  _excluded2 = ["open", "dataCyRole"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var useStyles = (0, _styles.makeStyles)(function () {
  return {
    root: {
      padding: 0
    },
    typography: {
      '&:hover': {
        cursor: 'pointer'
      }
    },
    menuPaper: {
      padding: 12
    },
    selectedTypography: {
      fontWeight: 600
    }
  };
});
var TypographyListMenu = function TypographyListMenu(_ref) {
  var children = _ref.children,
    PaperProps = _ref.PaperProps,
    menuVariant = _ref.menuVariant,
    _ref$anchorProps = _ref.anchorProps,
    anchorProps = _ref$anchorProps === void 0 ? {} : _ref$anchorProps,
    count = _ref.count,
    unitsLabel = _ref.unitsLabel,
    disableMenu = _ref.disableMenu,
    props = _objectWithoutProperties(_ref, _excluded);
  var menuClasses = useStyles();
  var listProps = {
    'data-cy': _TypographyList.dataCy,
    className: menuClasses.root
  };
  if (disableMenu) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], {
      color: 'primary',
      variant: menuVariant,
      children: [count, " ", unitsLabel]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu["default"], _objectSpread(_objectSpread({
    hover: true,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    PaperProps: _objectSpread(_objectSpread({}, PaperProps), {}, {
      className: (0, _clsx2["default"])(menuClasses.menuPaper, PaperProps === null || PaperProps === void 0 ? void 0 : PaperProps.className)
    }),
    MenuListProps: _objectSpread(_objectSpread({}, listProps), {}, {
      component: 'div'
    }),
    anchor: function anchor(_ref2, i) {
      var open = _ref2.open,
        dataCyRole = _ref2.dataCyRole,
        p = _objectWithoutProperties(_ref2, _excluded2);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Typography["default"], _objectSpread(_objectSpread(_objectSpread({
        color: 'primary',
        variant: menuVariant,
        className: (0, _clsx2["default"])(menuClasses.typography, _defineProperty({}, menuClasses.selectedTypography, Boolean(open))),
        "data-cy-action": _TypographyList.dataCyActionOpenMenu,
        "data-cy-role": dataCyRole
      }, p), anchorProps), {}, {
        children: [count, " ", unitsLabel]
      }), i);
    }
  }, props), {}, {
    children: children
  }));
};
var _default = exports["default"] = TypographyListMenu;